'use client';

import { useEffect, useState } from 'react';
import Loader from './loader';

export function NavigationLoader() {
      const [isLoading, setIsLoading] = useState(false);

      useEffect(() => {
            const handleStart = (url: string) => {
                  // Não mostrar loader para navegações de hash na mesma página
                  if (url.includes('#') && url.split('#')[0] === window.location.pathname) return;
                  setIsLoading(true);
            };

            const handleComplete = () => {
                  setIsLoading(false);
            };

            // Adicionar event listeners para eventos de navegação
            document.addEventListener('routeChangeStart', handleStart as unknown as EventListener);
            document.addEventListener('routeChangeComplete', handleComplete);
            document.addEventListener('routeChangeError', handleComplete);

            return () => {
                  document.removeEventListener('routeChangeStart', handleStart as unknown as EventListener);
                  document.removeEventListener('routeChangeComplete', handleComplete);
                  document.removeEventListener('routeChangeError', handleComplete);
            };
      }, []);

      return isLoading ? <Loader fullScreen /> : null;
} 